type RadiusValue = {
	tokenName: string;
	suitableFor: string;
	value: string;
	focusTokenName?: string;
	focusRingRadiusValue?: string;
};

export const values: RadiusValue[] = [
	{
		tokenName: 'radius.xsmall',
		suitableFor: 'Small detail elements: badges, checkboxes, avatar labels, keyboard shortcuts.',
		value: '2px',
		focusTokenName: 'radius.focus.xsmall',
		focusRingRadiusValue: '4px (xsmall +2 offset)',
	},
	{
		tokenName: 'radius.small',
		suitableFor:
			'Supporting elements: labels, lozenges, timestamps, tags, dates, tooltip containers, imagery inside a table, compact buttons.',
		value: '4px',
		focusTokenName: 'radius.focus.small',
		focusRingRadiusValue: '6px (small +2 offset)',
	},
	{
		tokenName: 'radius.medium',
		suitableFor:
			'Interactive elements: buttons, inputs, text areas, selects, navigation items, smart links.',
		value: '6px',
		focusTokenName: 'radius.focus.medium',
		focusRingRadiusValue: '8px (medium +2 offset)',
	},
	{
		tokenName: 'radius.large',
		suitableFor: 'Containment elements: cards, in-page containers, floating UI, dropdown menus.',
		value: '8px',
		focusTokenName: 'radius.focus.large',
		focusRingRadiusValue: '10px (large +2 offset)',
	},
	{
		tokenName: 'radius.xlarge',
		suitableFor:
			'Large page elements: full-page containers, large containers, modals, Kanban columns, tables.',
		value: '12px',
		focusTokenName: 'radius.focus.xlarge',
		focusRingRadiusValue: '14px (xlarge +2 offset)',
	},
	{
		tokenName: 'radius.xxlarge',
		suitableFor: 'Video player containers.',
		value: '16px',
		focusTokenName: 'radius.focus.xxlarge',
		focusRingRadiusValue: '18px (xxlarge +2 offset)',
	},
	{
		tokenName: 'radius.full',
		suitableFor:
			'Circular elements (user/people related): avatars, names, user-related UI, emoji reactions.',
		value: '999px',
	},
	{
		tokenName: 'radius.tile',
		suitableFor: 'Use this specific radius token exclusively for the tile component system.',
		value: 'Calculated 25%',
	},
];
